import { Dialog } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SubscriptionRequiredContent from './SubscriptionRequiredContent';

/**
 * Modal shown when a user without an active subscription attempts a gated action
 * (create case, upload documents).
 */
export default function SubscriptionRequiredDialog({ open, onClose }) {
    const navigate = useNavigate();

    function handleChoosePlan() {
        onClose();
        navigate('/account');
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="subscription-required-title"
            aria-describedby="subscription-required-description"
        >
            <SubscriptionRequiredContent
                variant="dialog"
                onChoosePlan={handleChoosePlan}
                onCancel={onClose}
                showCancel
            />
        </Dialog>
    );
}
